import React, { Component } from "react";
import styled from "styled-components";
import LogoSrc from "./../../public/img/logo-rsp.png";

const Logo = styled.img`
  width: 100%;
  height: 200px;
`;

class Atas extends Component {
  render() {
    return <Logo src={LogoSrc} />;
  }
}

export default Atas;
